import React from 'react';
import { t } from 'i18next';
import { Heading, HeadingType } from '@sovryn/ui';
import { StatusIcon } from '../../../../2_molecules/StatusIcon/StatusIcon';
import { getStatus } from './TxStatusTitle.utils';
export const TxStatusTitle = ({ step, }) => {
    const { title, status } = getStatus(step);
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { type: HeadingType.h2, className: "font-medium mb-8" }, t(title)),
        status && (React.createElement("div", { className: "mb-8" },
            React.createElement(StatusIcon, { status: status })))));
};
